module.exports = __webpack_public_path__ + "img/banner1.4bed5f96.jpg";